/**
 * Side menu related constants
 */
type sideMenuType = {
  parentText: string;
  children: {
    href: string;
    text: string;
  }[];
}[];

export const sideMenuAccordionItems: sideMenuType = [
  {
    parentText: "マイページ",
    children: [
      {
        href: "/messages",
        text: "メッセージ一覧",
      },
      {
        href: "/accounts",
        text: "アカウント設定",
      },
      {
        href: "/logout",
        text: "ログアウト",
      },
    ],
  },
  {
    parentText: "サービス",
    children: [
      {
        href: "/services",
        text: "サービス一覧",
      },
      {
        href: "/files",
        text: "素材管理",
      },
      {
        href: "/template-list",
        text: "テンプレート管理",
      },
    ],
  },
  {
    parentText: "顧客",
    children: [
      {
        href: "/customers",
        text: "顧客一覧",
      },
      {
        href: "/reservations",
        text: "予約・申込一覧",
      },
    ],
  },
  {
    parentText: "集客情報",
    children: [
      {
        href: "/earnings",
        text: "売上",
      },
      {
        href: "/analytics/customer",
        text: "分析",
      },
    ],
  },
  {
    parentText: "集客",
    children: [
      {
        href: "/journeys",
        text: "ジャーニー管理",
      },
      {
        href: "/mails",
        text: "メール配信",
      },
    ],
  },
];

export const sideMenuTopItems: { href: string; text: string }[] = [
  {
    href: "/mypage",
    text: "TOP(仮)",
  },
];

export const sideMenuBottomItems: { href: string; text: string }[] = [
  {
    href: "/helps",
    text: "ヘルプページ",
  },
];
